<template>
  <div class="intro-y flex items-center">
    <h2 class="text-2xl font-medium mr-auto capitalize">
      <slot></slot>
    </h2>

    <div v-if="!!$slots.leftSide">
      <slot name="leftSide"></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
